// Stacked bar of time spent in each HR zone (from the session's saved hr_zone_distribution).
import { ZONE_KEYS } from '@/lib/hrZones';

const ZONE_STYLE = {
  ut3: { label: 'UT3', color: '#9AA4AE' },
  ut2: { label: 'UT2', color: '#2F80ED' },
  ut1: { label: 'UT1', color: '#21B86A' },
  at: { label: 'AT', color: '#F5C518' },
  tr: { label: 'TR', color: '#F2711C' },
  an: { label: 'AN', color: '#E5403A' },
};

const fmtMin = (s) => (s >= 60 ? `${Math.round(s / 60)}m` : `${Math.round(s)}s`);

export const ZoneTimeBar = ({ workout }) => {
  const dist = workout?.hr_zone_distribution;
  if (!dist || !ZONE_KEYS.some((k) => dist[k] > 0)) return null;
  const total = workout.elapsed_time_s || workout.duration || 0;
  const zones = ZONE_KEYS.filter((k) => dist[k] > 0);
  const id = workout.workout_id;
  return (
    <div className="mt-3" data-testid={`zone-time-bar-${id}`}>
      <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-zinc-100">
        {zones.map((k) => (
          <div
            key={k}
            title={`${ZONE_STYLE[k].label} · ${Math.round(dist[k] * 100)}%`}
            style={{ width: `${dist[k] * 100}%`, backgroundColor: ZONE_STYLE[k].color }}
            className="h-full transition-[width] duration-500"
            data-testid={`zone-time-seg-${k}-${id}`}
          />
        ))}
      </div>
      <div className="mt-1.5 flex flex-wrap gap-x-3 gap-y-1 text-[10px] font-bold tracking-wider text-zinc-500">
        {zones.map((k) => (
          <span key={k} className="flex items-center gap-1" data-testid={`zone-time-label-${k}-${id}`}>
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: ZONE_STYLE[k].color }} />
            {ZONE_STYLE[k].label} {Math.round(dist[k] * 100)}%{total > 0 ? ` · ${fmtMin(dist[k] * total)}` : ''}
          </span>
        ))}
      </div>
    </div>
  );
};
